import React, {useEffect} from 'react';
import {connect} from 'react-redux';

import {isEmpty} from 'lodash';

import AreasTable from './AreasTable';

import ActionBar from '../../components/ActionBar';
import { TabContent } from '../../components/TabPanel';

import * as ArchitectActions from '../../actions/architectActions';

import classes from './TableAndSearch.module.css';

const AreasTableAndSearch = ({
    areas,
    fetchAreasByEquipmentId,
    handleSort,
    order,
    orderBy,
    selectedNode,
    ...props
}) => {

    useEffect(() => {
        fetchAreasByEquipmentId(selectedNode);
    }, []);

    const handleSearch = searchFilter => {
        if (isEmpty(searchFilter)) {
            fetchAreasByEquipmentId(selectedNode);
        } else {
            fetchAreasByEquipmentId(selectedNode, {searchFilter});
        }
    };

    return (
        <TabContent
            classes={{
                root: classes.tabContent
            }}
        >
            <ActionBar
                onSearch={handleSearch}
            />
            <div className={classes.scrollContainer}>
                <AreasTable
                    areas={areas}
                    order={order}
                    orderBy={orderBy}
                    onSort={property => handleSort(props, property)}
                />
            </div>
        </TabContent>
    );
};

const mapDispatchToProps = {
    ...ArchitectActions
};

export default connect(null, mapDispatchToProps)(AreasTableAndSearch);
